import { values } from 'lodash';
import PropTypes from 'prop-types';

import { useHasPermissionWithValues } from './hooks/useHasPermission';

export const WithPermissions = (props) => {
  const { permission = [], itemToCheck, children } = props;
  const { hasPermission, permissionValues } = useHasPermissionWithValues(
    permission,
    itemToCheck,
  );

  const renderedChildren = children(hasPermission, values(permissionValues));

  return renderedChildren || null;
};

WithPermissions.propTypes = {
  permission: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  itemToCheck: PropTypes.object,
  children: PropTypes.func.isRequired,
};

export {
  EDIT_PERMISSIONS,
  NAVIGATION_PERMISSIONS,
  VISIBILITY_PERMISSIONS,
} from './constants';
